const authConstants = {
  loginSuccess: 'auth-login-success',
  loginFailed: 'auth-login-failed',
  logoutSuccess: 'auth-logout-success',
  sessionTimeout: 'auth-session-timeout',
  notAuthenticated: 'auth-not-authenticated',
  notAuthorized: 'auth-not-authorized',
  sctAuthSuccess: 'sct-auth-success'
};

export default authConstants;



// WEBPACK FOOTER //
// ./src/constants/authConstants.js